import styles from "./card.module.css";

export default function CardContainer({ children }) {
    return (
      <div className={styles.container}>{children}</div>
    )
}